import {
  EXERCISE_THUMBNAIL_BASE_PATH,
  EXERCISE_THUMBNAIL_EXTENSION,
} from '../constants/exercise.constants';
import { splitFileNameAndExtension } from './file.utils';

/**
 * Builds the exercise thumbnail URL from its video link, e.g.
 * `https://storage.googleapis.com/golfdr-motion-core-exercises/exercises/<Name>.mp4`
 * -> `//storage.googleapis.com/golfdr-motion-core-exercises/exercises/thumbnails/<Name>.jpg`
 */
export function getExerciseThumbnailUrl(videoLink: string): string {
  const videoFileName = videoLink.split(/[?#]/)[0].split('/').pop();
  if (!videoFileName) return '';

  const { fileName } = splitFileNameAndExtension(videoFileName);
  return `${EXERCISE_THUMBNAIL_BASE_PATH}/${fileName}.${EXERCISE_THUMBNAIL_EXTENSION}`;
}
